import React, { FC } from 'react';
import { PermissionName } from '../../shared/permissions';
import { checkPermission, useUser } from '../utils';
import { AccessDenied } from './AccessDenied';

interface PermissionBoundaryProps {
  readonly inline?: boolean;
  readonly requiredPermissions?: PermissionName[];
  readonly matchAny?: boolean;
}

const emptyArray: PermissionName[] = [];

export const PermissionBoundary: FC<PermissionBoundaryProps> = ({
  children,
  inline = false,
  requiredPermissions = emptyArray,
  matchAny = false,
}) => {
  const user = useUser();

  if (
    (!user && requiredPermissions.length > 0) ||
    !checkPermission(user!, requiredPermissions, matchAny)
  ) {
    return inline ? null : <AccessDenied />;
  }

  return <>{children}</>;
};
